"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _utils = require("../../utils");

var _hooks = require("../../utils/hooks");

var _analysis = require("../../../../context/analysis");

var _navigate = require("../../../../utils/routes/navigate");

var _insights = require("../../../../context/insights");

const DEFAULT_LOAD_COUNT = 10;
const GoToEquip = (0, _styledComponents.default)(_reactRouterDom.Link)`
  color: inherit;
  text-decoration: none;
  display: contents;

  /** CSS hack to add border-top to the first All Associated row */
  &.default-density-row
    + .compact-density-row
    > .DataGrid-Row
    > .DataGrid-Cell {
    border-top: 2px solid ${_blocks.palette.neutral4};
  }

  &.LastVisited .DataGrid-Cell {
    background-color: ${_blocks.color.theme.state.currentActive.background};
  }
`;
const StyledDataGridFooter = (0, _styledComponents.default)(_blocks.DataGridFooter)`
  border-width: 1px 0px 0px;
  border-color: initial;
  border-top: 1px solid;
  border-image: linear-gradient(
      270deg,
      rgb(247, 249, 250) 0%,
      rgb(207, 211, 214) 50%,
      rgb(247, 249, 250) 100%
    )
    1 / 1 / 0 stretch;
`;
const Grid = (0, _styledComponents.default)(_blocks.DataGrid)`
  user-select: none;
`;

function calcClassName(actionsCount, targetCount, isActive) {
  const density = actionsCount === targetCount ? 'compact-density-row' : 'default-density-row';
  const active = isActive ? 'LastVisited' : '';
  return `${density} ${active}`;
}

function getOccurrenceIdentity(occ) {
  return `${occ.id}-${occ.ruleId}-${occ.site.syncoId}`;
}

const GroupGrid = ({
  groupAssets,
  occurrences,
  filtered,
  persistKey,
  showSnoozed
}) => {
  if (occurrences.length === 0) {
    return null;
  }

  const {
    viewMode
  } = (0, _analysis.useState)();
  const {
    lastActiveRow
  } = (0, _insights.useState)();
  const {
    setLastActiveRow
  } = (0, _insights.useActions)();
  const {
    sorted,
    currentCount,
    activeSort,
    sortDirection,
    onSort,
    setCurrentCount,
    totalCount
  } = (0, _hooks.useGridState)(occurrences, filtered, persistKey);
  const [actioned, setActioned] = React.useState({
    actioned: [],
    unactioned: []
  });
  React.useLayoutEffect(() => {
    if (sorted.length > 0) {
      setActioned((0, _utils.splitActioned)(sorted));
    }
  }, [sorted]);
  const rows = React.useMemo(() => [...actioned.unactioned, ...actioned.actioned], [actioned]);
  const handleSetLastActive = React.useCallback(id => {
    return () => {
      setLastActiveRow(id);
    };
  }, []);
  const {
    Header,
    Row,
    Footer,
    grid
  } = groupAssets;
  const equipCount = (0, _utils.getEquipsCount)(occurrences, showSnoozed);
  const hitCount = (0, _utils.getHitsCount)(occurrences, showSnoozed);
  const remainingCount = totalCount - currentCount;
  const moreCount = remainingCount > DEFAULT_LOAD_COUNT ? DEFAULT_LOAD_COUNT : remainingCount;

  if (actioned.actioned.length === 0 && actioned.unactioned.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Grid, {
    columns: grid.columns,
    group: grid.group,
    hide: grid.hide,
    grow: grid.grow,
    cellProps: {
      type: 'dense',
      density: 'default'
    }
  }, /*#__PURE__*/React.createElement(_blocks.DataGridHeader, {
    cursor: "pointer"
  }, /*#__PURE__*/React.createElement(Header, {
    activeSort: activeSort,
    sortDirection: sortDirection,
    groupCount: totalCount,
    equipCount: equipCount,
    hitCount: hitCount,
    onSort: onSort(activeSort, true)
  })), rows.slice(0, currentCount).map(occurrence => {
    const renderRow = showSnoozed === true || occurrence.activeHits > 0;
    const rowId = getOccurrenceIdentity(occurrence);
    return renderRow ? /*#__PURE__*/React.createElement(GoToEquip, {
      key: occurrence.id,
      to: {
        pathname: (0, _navigate.getLinkTo)(`/analysis/${viewMode}/${occurrence.site.syncoId}/${occurrence.ruleId}`).pathname,
        search: (0, _navigate.getLinkTo)(`/analysis/${viewMode}/${occurrence.site.syncoId}/${occurrence.ruleId}`).search,
        state: {
          previous: window.location.pathname
        }
      },
      onClick: handleSetLastActive(rowId),
      "data-cy": occurrence.ruleName,
      className: calcClassName(occurrence.actionsCount, occurrence.targetCount, rowId === lastActiveRow)
    }, /*#__PURE__*/React.createElement(_blocks.DataGridRow, {
      cursor: "pointer",
      density: occurrence.actionsCount === occurrence.targetCount ? 'compact' : 'default'
    }, /*#__PURE__*/React.createElement(Row, (0, _extends2.default)({
      showSnoozed: showSnoozed === true
    }, occurrence)))) : null;
  }), /*#__PURE__*/React.createElement(StyledDataGridFooter, null, /*#__PURE__*/React.createElement(Footer, {
    moreCount: moreCount,
    currentCount: currentCount,
    totalCount: totalCount,
    onLoadMore: () => setCurrentCount(currentCount + moreCount),
    onLoadAll: () => setCurrentCount(totalCount),
    exportData: occurrences,
    viewMode: viewMode
  })));
};

var _default = GroupGrid;
exports.default = _default;
module.exports = exports.default;